export default {
  hasAirportShuttle(amenityList) {
    //es6 refactor - ternary expression not working nor default includes() return
    if(amenityList.includes('airport shuttle (on site)')) {
      return true
    } else {
      return false
    }
  },

  includesBreakfast(amenityList) {
    if(amenityList.includes('complimentary breakfast (on site)')) {
      return true
    } else {
      return false
    }
  },

  hasBusinessCenter(amenityList) {
    if(amenityList.includes('business center (on site)')) {
      return true
    } else {
      return false
    }
  },

  hasFitnessCenter(amenityList) {
    if(amenityList.includes('fitness center (on site)')) {
      return true
    } else {
      return false
    }
  },

  includesInternet(amenityList) {
    if(amenityList.includes('internet access (on site)')) {
      return true
    } else {
      return false
    }
  },

  allowPets(amenityList) {
    if(amenityList.includes('pets allowed (contact hotel) (on site)')) {
      return true
    } else {
      return false
    }
  },

  hasPool(amenityList) {
    if(amenityList.includes('pool (on site)')) {
      return true
    } else {
      return false
    }
  },

  hasRestaurant(amenityList) {
    if(amenityList.includes('resturant on site (on site)')) {
      return true
    } else {
      return false
    }
  }
}
